export const actionsUser = {
  CONSULTA: 'CONSULTA',
  ALTA: 'ALTA',
  MODIFICA: 'MODIFICA',
  BAJA: 'BAJA',
  EJECUTAR: 'EJECUTAR',
  EXPORTAR: 'EXPORTAR',
  IMPORTAR: 'IMPORTAR',
  DETALLE: 'DETALLE',
  VALIDAR: 'VALIDAR',

  // Modulo AUTOGESTION
  AUTORIDAD_INFORMACION_PERSONAL_CONSTANCIA: 'AUTORIDAD_INFORMACION_PERSONAL_CONSTANCIA',
  AUTORIDAD_INFORMACION_PERSONAL_EXCUSARSE: 'AUTORIDAD_INFORMACION_PERSONAL_EXCUSARSE',
  AUTORIDAD_INFORMACION_PERSONAL_CONSULTA: 'AUTORIDAD_INFORMACION_PERSONAL_CONSULTA',
  AUTORIDAD_INFORMACION_PERSONAL_EDITAR: 'AUTORIDAD_INFORMACION_PERSONAL_EDITAR',
  AUTORIDAD_INFORMACION_PERSONAL_CEDULA: 'AUTORIDAD_INFORMACION_PERSONAL_CEDULA',
  AUTORIDAD_INSCRIPCIONES: 'AUTORIDAD_INSCRIPCIONES',
  AUTORIDAD_PAGOS: 'AUTORIDAD_PAGOS',
  DELEGADO_MESAS_MODIFICAR: 'DELEGADO_MESAS_MODIFICAR',
  DELEGADO_MESAS_ALTA: 'DELEGADO_AUTORIDAD_MESA_ALTA',

  // Action Id

  OBSERVACION: 'observacion',
  SUBSANAR: 'subsanar',
  NOSUBSANAR: 'nosubsanar',
  DESCARGAR: 'descargar',
};
